import { render } from "./AdminDeviceManagement.vue?vue&type=template&id=5269a984&scoped=true"
import script from "./AdminDeviceManagement.vue?vue&type=script&lang=js"
export * from "./AdminDeviceManagement.vue?vue&type=script&lang=js"

import "./AdminDeviceManagement.vue?vue&type=style&index=0&id=5269a984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5269a984"]])

export default __exports__